module.exports = __webpack_public_path__ + "img/Plakat.9195be33.jpg";